import { Button, Form, Input, Upload, message } from 'antd';
import React from 'react';
import { RcFile } from 'antd/lib/upload';
import { translations } from '../../../config/translations';
import { FormTemplatesClient, FormTemplateVm } from '../../../utils/api';

type Props = {
    onClose: () => void;
    onSuccess: () => void;
    formTemplate?: FormTemplateVm;
};

type State = {
    file?: RcFile;
    submitting?: boolean;
};

class FormTemplatesForm extends React.Component<Props, State> {
    state: State = {};

    private handleSubmit = async (values: any) => {
        const { file } = this.state;
        const isEdit = !!this.props.formTemplate?.id;
        if (!file && !isEdit) {
            message.error('Datoteka je obavezna.');
            return;
        }

        this.setState({ submitting: true });
        try {
            const client = new FormTemplatesClient();
            if (isEdit) {
                const id = this.props.formTemplate!.id;
                await client.update(
                    id,
                    id,
                    file ? { data: file, fileName: file.name } : undefined,
                    values.remark ?? null
                );
            } else {
                await client.create({ data: file!, fileName: file!.name }, values.remark ?? null);
            }
            message.success(translations.formTemplates.saveSuccess);
            this.props.onSuccess();
        } catch (e) {
            message.error(translations.general.errorSavingData);
        } finally {
            this.setState({ submitting: false });
        }
    };

    render(): React.ReactElement {
        const { formTemplate } = this.props;
        const isEdit = !!formTemplate?.id;
        const uploadProps = {
            beforeUpload: (f: RcFile) => {
                if (isEdit) return false;
                this.setState({ file: f });
                return false;
            },
            multiple: false,
            maxCount: 1,
            disabled: isEdit,
            showUploadList: {
                showRemoveIcon: false,
            } as any,
            fileList: isEdit
                ? [
                      {
                          uid: '-1',
                          name: formTemplate!.fileName as any,
                          status: 'done' as any,
                      },
                  ]
                : undefined,
        } as any;

        return (
            <Form
                layout="vertical"
                onFinish={this.handleSubmit}
                initialValues={{ remark: formTemplate?.remark }}
            >
                <Form.Item label={translations.general.upload} required={!formTemplate}>
                    <Upload {...uploadProps}>
                        <Button disabled={isEdit}>{translations.general.upload}</Button>
                    </Upload>
                </Form.Item>

                <Form.Item name="remark" label={translations.formTemplates.remark}>
                    <Input.TextArea rows={3} />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={this.state.submitting}>
                        {translations.general.save}
                    </Button>
                    <Button style={{ marginLeft: 8 }} onClick={this.props.onClose}>
                        {translations.general.cancel}
                    </Button>
                </Form.Item>
            </Form>
        );
    }
}

export default FormTemplatesForm;
